import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, inject } from '@angular/core';
import { WikiPanelService } from '../../services/wiki/wiki-panel.service';
import { WikiAttentionService } from '../../services/wiki/wiki-attention.service';

@Component({
  selector: 'app-wiki-attention-modal',
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './wiki-attention-modal.component.html',
  styleUrl: './wiki-attention-modal.component.scss',
})
export class WikiAttentionModalComponent {
  @Input() visible = false;
  @Output() closeModal = new EventEmitter<void>();

  readonly wikiAttentionService = inject(WikiAttentionService);
  private readonly wikiPanelService = inject(WikiPanelService);

  readonly setupTopics = [
    {
      id: 'setup-overview',
      icon: 'pi-flag',
      title: 'Initial Setup Checklist',
      description: 'Recommended order before adding employees and running payroll.',
    },
    {
      id: 'organization-setup',
      icon: 'pi-sitemap',
      title: 'Organization Setup',
      description: 'Departments, positions, schedules, and holidays.',
    },
    {
      id: 'payroll-setup',
      icon: 'pi-wallet',
      title: 'Payroll Configuration',
      description: 'Pay schedules, periods, contributions, and tax brackets.',
    },
    {
      id: 'approval-setup',
      icon: 'pi-check-square',
      title: 'Approval Policies',
      description: 'Workflows and department policy assignments.',
    },
  ];

  readonly tutorialTopics = [
    {
      id: 'tutorial-payroll-run',
      icon: 'pi-play-circle',
      title: 'How to Run Payroll',
      description: 'Create a run, review results, and publish payslips.',
    },
    {
      id: 'tutorial-leave-management',
      icon: 'pi-sun',
      title: 'Leave Management',
      description: 'Review requests, balances, and leave types.',
    },
    {
      id: 'tutorial-dtr',
      icon: 'pi-calendar',
      title: 'DTR & Attendance',
      description: 'Submissions, approvals, and attendance records.',
    },
    {
      id: 'tutorial-employee-onboarding',
      icon: 'pi-users',
      title: 'Employee Onboarding',
      description: 'Add employees and prepare them for payroll.',
    },
  ];

  close(): void {
    this.closeModal.emit();
  }

  openWikiTopic(topicId: string): void {
    this.wikiPanelService.open(topicId);
    this.close();
  }

  openSetupGuide(): void {
    this.openWikiTopic('setup-overview');
  }

  openTutorials(): void {
    this.openWikiTopic('tutorials-index');
  }

  dismissForSession(): void {
    this.wikiAttentionService.closeForSession();
    this.close();
  }

  dontShowAgain(): void {
    this.wikiAttentionService.acknowledgePermanently();
    this.close();
  }
}
